import { useState } from "react";
import { Button, showToast } from "@xpense/ui";
import { api } from "../api/client";
import { MetricCard, Page, Section } from "../components/Page";
import { Icon } from "../components/Icons";

export default function Export() {
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const data = await api.get<any>("/api/v1/export");
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `xpense-export-${new Date().toISOString().split("T")[0]}.json`;
      a.click();
      URL.revokeObjectURL(url);
      showToast("Data exported successfully", "success");
    } catch (err) {
      showToast(err instanceof Error ? err.message : "Failed to export data", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!confirm("Delete all Xpense AI data? This cannot be undone.")) {
      return;
    }
    setDeleting(true);
    try {
      await api.delete("/api/v1/export");
      showToast("All data deleted successfully", "success");
    } catch (err) {
      showToast(err instanceof Error ? err.message : "Failed to delete data", "error");
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Page
      eyebrow="Data control"
      title="Export and Delete"
      description="Download your complete account data or permanently remove it from the workspace."
    >
      <div className="xpn-grid xpn-grid--3">
        <MetricCard label="Format" value="JSON" caption="Portable full export" tone="info" />
        <MetricCard label="Scope" value="All data" caption="Transactions, events, forecasts" />
        <MetricCard label="Deletion" value="Permanent" caption="Requires confirmation" tone="danger" />
      </div>

      <div className="xpn-grid xpn-grid--2">
        <Section
          title="Export data"
          description="Download all transactions, raw events, and forecast records as a JSON file."
        >
          <div className="xpn-section-body">
            <Button onClick={handleExport} loading={loading}>
              <Icon name="download" />
              Export All Data
            </Button>
          </div>
        </Section>

        <Section
          title="Delete all data"
          description="Permanently remove transactions, raw events, forecasts, and account history."
          style={{ borderColor: "rgba(217, 79, 69, 0.32)" }}
        >
          <div className="xpn-section-body">
            <p className="xpn-text-body-md xpn-text-muted xpn-mb-lg">
              This action cannot be undone. Export first if you need a backup.
            </p>
            <Button variant="danger" onClick={handleDelete} loading={deleting}>
              <Icon name="trash" />
              Delete All Data
            </Button>
          </div>
        </Section>
      </div>
    </Page>
  );
}
